{
  "R": [0, 148, 183, 223, 247, 252],
  "G": [0, 44, 55, 74, 112, 253],
  "B": [4, 128, 121, 104, 92, 191],
  "A": [0, 44, 53, 64, 75, 107],
  "I": [0, 107, 128, 154, 179, 255]
}
